var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPawprintFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72508 19.7927C10.182 19.6268 10.6307 19.4638 11.3414 19.4278C12.0715 19.4278 12.4653 19.6058 12.8824 19.7944C13.381 20.0198 13.9128 20.2603 15.092 20.2297C16.9312 20.182 18.2197 18.3835 17.723 16.612C15.4194 8.39536 7.24695 8.04125 4.9683 16.5922C4.49311 18.3754 5.79134 20.1906 7.63676 20.1886C8.63798 20.1875 9.18716 19.9881 9.72508 19.7927Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81955 9.43825C11.3434 9.43825 12.5788 7.997 12.5788 6.21913C12.5788 4.44125 11.3434 3 9.81955 3C8.29566 3 7.0603 4.44125 7.0603 6.21913C7.0603 7.997 8.29566 9.43825 9.81955 9.43825Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53144 11.7154C7.69396 11.0227 7.98125 9.36172 7.17312 8.00544C6.36499 6.64916 4.76746 6.11121 3.60494 6.80389C2.44241 7.49657 2.15512 9.15759 2.96325 10.5139C3.77138 11.8701 5.36891 12.4081 6.53144 11.7154Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2856 10.1895C15.636 10.7769 17.2727 10.0072 17.9412 8.47037C18.6096 6.93354 18.0567 5.21151 16.7062 4.62411C15.3558 4.03672 13.7191 4.8064 13.0506 6.34324C12.3822 7.88007 12.9351 9.6021 14.2856 10.1895Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6684 13.4482C17.4777 14.5075 19.1111 14.6196 20.3166 13.6986C21.522 12.7776 21.8432 11.1722 21.0338 10.1129C20.2245 9.05356 18.5911 8.94148 17.3856 9.86252C16.1802 10.7836 15.859 12.3889 16.6684 13.4482Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawprintFilled);
export default __webpack_public_path__ + "static/media/pawprint-filled.8852fe53aecfb7c5d1a6d3a52eda3b89.svg";
export { ForwardRef as ReactComponent };